import EnvConfigUtil from './EnvConfigUtil';

export const getEnvConfigByKeyForLogin = (key: string): string | null => {
  return EnvConfigUtil.getEnvConfigByKey(ENV_TO_CONFIGS_FOR_LOGIN, key);
};

const ENV_TO_CONFIGS_FOR_LOGIN: { [env: string]: any } = {
  sandbox: {
    securityUrl:
      'https://nddyyzagji.execute-api.us-east-1.amazonaws.com/sandbox',
    giUrl: 'https://amzheimdall-na.integ.amazon.com',
    giClientId: 'AET-Thunder-beta-na',
  },
  beta_internal_na: {
    securityUrl:
      'https://dmo7k4wd9k.execute-api.us-east-1.amazonaws.com/beta-internal',
    giUrl: 'https://amzheimdall-na.integ.amazon.com',
    giClientId: 'AET-Thunder-beta-na',
  },
  beta_na: {
    securityUrl: 'https://wa6x1hnkl2.execute-api.us-east-1.amazonaws.com/beta',
    giUrl: 'https://amzheimdall-na.integ.amazon.com',
    giClientId: 'AET-Thunder-beta-na',
  },
  gamma_na: {
    securityUrl:
      'https://qj5nr90s05.execute-api.us-east-1.amazonaws.com/gamma-us-east-1',
    giUrl: 'https://na.amzheimdall.com',
    giClientId: 'AET-Thunder-gamma-na',
  },
  gamma_eu: {
    securityUrl:
      'https://ixek9glde6.execute-api.eu-west-1.amazonaws.com/gamma-eu-west-1',
    giUrl: 'https://eu.amzheimdall.com',
    giClientId: 'AET-Thunder-gamma-eu',
  },
  gamma_fe: {
    securityUrl:
      'https://oi5re24sy2.execute-api.us-west-2.amazonaws.com/gamma-us-west-2',
    giUrl: 'https://fe.amzheimdall.com',
    giClientId: 'AET-Thunder-gamma-fe',
  },
  gamma_cn: {
    securityUrl:
      'https://pdkfiuwn30.execute-api.cn-north-1.amazonaws.com.cn/gamma-cn-north-1',
    giUrl: 'https://cn.amzheimdall.com',
    giClientId: 'AET-Thunder-gamma-cn',
  },
  prod_na: {
    securityUrl:
      'https://cy0e5tauc3.execute-api.us-east-1.amazonaws.com/prod-us-east-1',
    giUrl: 'https://na.amzheimdall.com',
    giClientId: 'AET-Thunder-prod-na',
  },
  prod_eu: {
    securityUrl:
      'https://f85fp5lzi2.execute-api.eu-west-1.amazonaws.com/prod-eu-west-1',
    giUrl: 'https://eu.amzheimdall.com',
    giClientId: 'AET-Thunder-prod-eu',
  },
  prod_fe: {
    securityUrl:
      'https://3q5fk7e8n5.execute-api.us-west-2.amazonaws.com/prod-us-west-2',
    giUrl: 'https://fe.amzheimdall.com',
    giClientId: 'AET-Thunder-prod-fe',
  },
  prod_cn: {
    securityUrl:
      'https://zeci3879m7.execute-api.cn-north-1.amazonaws.com.cn/prod-cn-north-1',
    giUrl: 'https://cn.amzheimdall.com',
    giClientId: 'AET-Thunder-prod-cn',
  },
};
